module.exports = __webpack_public_path__ + "img/university_4981427.83ae35d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/university_4981427.png
// module id = 1752
// module chunks = 1